import { useLazyQuery } from '@apollo/client';
import React, { FC, useEffect, useState } from 'react';
import useHandlePaymentMethodUpdates from '../../hooks/useHandlePaymentMethodUpdates';
import { vars } from '../../reactive';
import { navigateRequiredOrdersForPaymentActions } from '../../utils/handleOrderPaymentAction';
import { GetAllPets } from '../../utils/queries';
import MainForm from './MainForm';

const AuthLoading: FC<{ branch: Queries.CollarAPI_Branch; provider?: Record<string, any>; isFormFill?: boolean }> = ({ branch, provider, isFormFill }) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [getProfile, { loading: userProfileLoading }] = useLazyQuery<{
    getProfile: Queries.CollarAPI_AppUser;
  }>(GetAllPets, {
    fetchPolicy: 'no-cache'
  });

  const loadingPayment = useHandlePaymentMethodUpdates();

  useEffect(() => {
    (async () => {
      if (vars.isLoggedIn()) {
        await getProfile().then(navigateRequiredOrdersForPaymentActions);
      }
      requestAnimationFrame(() => setLoading(false));
    })();
  }, []);

  return <MainForm authLoading={userProfileLoading || loading || loadingPayment} branch={branch} provider={provider} isFormFill={isFormFill} />;
};

export default AuthLoading;
